interface Props {
  title: string;
  text: string;
}

export default function TextInfo(props: Props) {
  const { text, title } = props;

  return (
    <div className="min-w-0 rounded-xl border border-border bg-white p-4 shadow-sm">
      <p className="text-xs font-bold uppercase tracking-wide text-muted">
        {title}
      </p>
      <p className="mt-1 break-words font-semibold text-gray">{text}</p>
    </div>
  );
}
